// import { useGetRawData } from "../../../pages/weather/lib/useGetRawData.ts";
import Loader from "@atomaro/ui-kit/components/Loader/Loader";
import {WeatherInfo} from "../../WeatherInfo";
import {WeatherCalendarMobile} from "../../WeatherCalendar/ui/WeatherCalendarMobile/WeatherCalendarMobile.tsx";
import {Divider, WidgetCalendarWrapper, WidgetTitle, WidgetWrap,} from "./styles.ts";
import {useNavigate} from "react-router-dom";
import {useWeatherStore} from "entities/weather/index.ts";

export const WeatherWidget = () => {
  
  const factForecast = useWeatherStore((s) => s.factForecast);
  const forecastDays = useWeatherStore((s) => s.forecastDays);
  
  const navigate = useNavigate();

  return (
    <WidgetWrap onClick={() => navigate("/weather")}>
      {!forecastDays || !factForecast ? (
        <Loader size={"m"} />
      ) : (
        <>
          <WeatherInfo forecast={factForecast} isWidget isGrid />
          <Divider />
          <WidgetCalendarWrapper>
            <WidgetTitle>Погода на 10 дней</WidgetTitle>
            <WeatherCalendarMobile days={forecastDays} isWidget />
          </WidgetCalendarWrapper>
        </>
      )}
    </WidgetWrap>
  );
};
